import axios from 'axios';
import React, { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { GlobalContext } from '../context/GlobalContext';
import { ArrowRightIcon } from '@heroicons/react/24/solid'

export const Cards = () => {

    const { state, handleFunction } = useContext(GlobalContext);

    let {
        display,
        setDisplay,
        data,
        setData,
        fetchStatus,
        setfetchStatus
    } = state

    let {
        setStatusSpan,
        longString,
        formatRupiah,
    } = handleFunction

    useEffect(() => {
        if (fetchStatus === true) {
            setDisplay(true)
            axios.get("https://dev-example.sanbercloud.com/api/job-vacancy").then((res) => {
                setData([...res.data.data])
                setDisplay(false)
            }).catch((error) => {
                console.log(error);
            })
            setfetchStatus(false)
        }
    }, [fetchStatus, setfetchStatus])


    return (
        <>
            {display &&

                <div
                    role="status"
                    className="p-4 max-w-sm rounded border border-gray-200 shadow animate-pulse md:p-6 dark:border-gray-700"
                >
                    <div className="flex justify-center items-center mb-4 h-48 bg-gray-300 rounded dark:bg-gray-700">
                        <svg
                            className="w-12 h-12 text-gray-200 dark:text-gray-600"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 640 512"
                        >
                            <path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
                        </svg>
                    </div>
                    <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4" />
                    <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5" />
                    <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5" />
                    <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700" />
                    <div className="flex items-center mt-4 space-x-3">
                        <svg
                            className="w-14 h-14 text-gray-200 dark:text-gray-700"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                                clipRule="evenodd"
                            />
                        </svg>
                        <div>
                            <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32 mb-2" />
                            <div className="w-48 h-2 bg-gray-200 rounded-full dark:bg-gray-700" />
                        </div>
                    </div>
                    <span className="sr-only">Loading...</span>
                </div>


            }
            {data !== null && data.map((res) => {
                return (
                    <div key={res.id} className="max-w-sm bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">

                        <img className="rounded-t-lg h-96 w-96" src={res.company_image_url} alt="" />
                        <div className="p-5">

                            <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                                {res.title}
                            </h5>
                            <div className='flex'>
                                <h5 className="mb-2 text-lg font-bold tracking-tight text-blue-600 dark:text-white mr-2">
                                    {res.company_name}
                                </h5>

                                {setStatusSpan(res.job_status)}
                            </div>
                            <h5 className="mb-2 text-lg font-bold tracking-tight text-gray-900 dark:text-white">
                                {formatRupiah(res.salary_min)} s/d {formatRupiah(res.salary_max)}
                            </h5>

                            <p className="mb-3 font-normal h-[144px] text-gray-700 dark:text-gray-400">
                                {longString(res.job_description)}
                            </p>
                            <Link to={`/list-job/${res.id}`}
                                className="inline-flex items-center py-2 px-3 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            >
                                Read more
                                <ArrowRightIcon className="ml-2 -mr-1 w-4 h-4" />
                            </Link>
                        </div>
                    </div>
                )
            })}
        </>
    )
}
